export default __webpack_public_path__ + "static/media/mainLogo.fe652e53.png";